const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const ScrollEvents = function()
{
    const parallaxWebdoor = function (el) {

        gsap.fromTo($(el).not(".no-plx").find('img, video'),
            {
                yPercent: 0,
                scale: 1,
            }, {
            yPercent: 35,
            scale: 1.2,
            ease: "none",
            scrollTrigger: {
                trigger: el,
                start: "top top",
                end: "bottom -=50%",
                scrub: true
            }
        });
    }
    

    const elmToScroll = function (el) {
        var	_this = el.attr('data-scrollto');
        scrollToElm(_this);
    }
    
    const scrollToElm = function (target) {
        gsap.to(window, {
            duration: 1, 
            scrollTo:(document.querySelector(target).offsetTop - document.querySelector('header').clientHeight),
            ease: 'Expo.easeOut',
            }
        );
    }

    const elmWebdoorScroll = (() =>{

        const logoWebdoor = document.querySelector('.scroll-elm-webdoor');
 
          gsap.to(logoWebdoor,{
            yPercent: 35,
            scale: "+=0.5",
            autoAlpha : 0,
            ease: "none",
            scrollTrigger: {
              trigger: ".webdoor",
              start: "top top",
              end: "bottom +=100",
              scrub: true
            }
          });

    })

    const expImage = (()=>{
        gsap.utils.toArray(".revealUp").forEach(el => {
            gsap.fromTo(el,
                {
                    scale : 1.4,
					yPercent: 55
                },{
                yPercent: 0,
                scale: 1,
                autoAlpha : 1,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    end: "center bottom",
                    scrub: 2
                }
              });
        })
        
    })

    const expImageRel = (()=>{
        gsap.utils.toArray(".revealUpRel").forEach(el => {
            gsap.fromTo(el,
                {
                    scale : 1.2,
					yPercent: 35
                },{
                yPercent: 0,
                scale: 1,
                autoAlpha : 1,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    end: "top bottom",
                    scrub: 2
                }
              });
        })
        
    })


    const gridScrollAnimate = (()=>{

        if( window.innerWidth < 712) return;

        gsap.utils.toArray(".gridScrollAnimate").forEach(el => {
            gsap.fromTo(el,
                {
					yPercent: 0
                },{
                yPercent: -35,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    start: "top center",
                    end: "bottom center",
                    scrub: 2
                }
              });
        })
        
    })

    const layerMaskAnimation = (()=>{
        gsap.utils.toArray(".mask-layer-animation").forEach(el => {
            gsap.to(el,{
                //height: 0,
                ease: "power4.out",
                duration: 1,
                scrollTrigger: {
                    trigger: el,
                    start: "-=25% center",
                    end: "center top",
                    scrub: 2,
                    toggleClass: 'motion-in',
                    //markers : true
                }
              });
        })
        
    })

    const footerAnimate = (()=>{

        const elmFooter = document.querySelector("footer");
            gsap.from(elmFooter, {
                scrollTrigger: {
                start: 'top 100%',
                trigger: elmFooter,
                toggleClass: 'motion-in'
                }
            });

    });

    return {
        init : function (el) {

            //logo home
            if(document.querySelector('.scroll-elm-webdoor')){
                elmWebdoorScroll();
            }
            
            if(document.querySelector('.mask-layer-animation')){
                layerMaskAnimation();
            }
            
            if(document.querySelector('.gridScrollAnimate')){
                gridScrollAnimate();
            }

            expImage();
            expImageRel();
            footerAnimate();

            if( $(".slick").not(".no-plx").length > 0 ) {
                parallaxWebdoor(".slick");
            }            

            $(document).on('click', '[data-scrollto]', function() {
                elmToScroll( $(this) );
            });

            //quando ajax carregado forca ir topo da pagina
            if(el) {
                scrollToElm(el);
            }

        }
    }

}();

module.exports = ScrollEvents;